var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetting = function SvgSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "inherit"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#inherit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.15 15.23h-9.408l-.032-.125a3.9 3.9 0 0 0-3.777-2.937 3.9 3.9 0 0 0-3.777 2.937l-.032.126H2.849a.853.853 0 0 0 0 1.706h1.275l.032.126A3.9 3.9 0 0 0 7.933 20a3.9 3.9 0 0 0 3.777-2.937l.032-.126h9.408a.853.853 0 0 0 0-1.706M7.933 18.295c-1.213 0-2.2-.992-2.2-2.21s.987-2.21 2.2-2.21 2.2.992 2.2 2.21-.986 2.21-2.2 2.21M2.85 8.77h9.407l.033.126a3.9 3.9 0 0 0 3.776 2.937 3.9 3.9 0 0 0 3.778-2.937l.032-.126h1.274a.853.853 0 0 0 0-1.707h-1.274l-.033-.126A3.9 3.9 0 0 0 16.067 4a3.9 3.9 0 0 0-3.777 2.937l-.032.126H2.85a.853.853 0 0 0 0 1.706m13.217-3.063c1.213 0 2.2.991 2.2 2.21s-.987 2.21-2.2 2.21-2.2-.992-2.2-2.21c0-1.219.986-2.21 2.2-2.21"
  }))));
};
export default SvgSetting;